import React, { useState, useEffect } from 'react';
import { Icon, IconClose } from '../../../base/icons';

// css for voice pitch
import './voice-pitch.css';

var url = window.location.href
var arr = url.split("/");
var result = arr[0] + "//" + arr[2];

const VoicePitch = ({ socket, Sessions, closeTool }) => {
  // hide buttons and cross buttons
  const [ isDisable, setIsDisable ] = useState(false);

  const { openByUser, SessionId } = Sessions;

  useEffect(
    () => {
      if (SessionId === openByUser) {
          setIsDisable(true);

          window.load_timber(`${result}/static/voice-pitch/`, "timber_demo_flash", "timber_demo_init", socket, openByUser);
      } else {
        socket.on('voicereturn',function(data){
          const { location } = data;

          if (location === window.location.href) {
            document.getElementById("timber_demo_flash").style.height="0px";

            for(let i=0; i<12; i++) {
                document.getElementById('note-' + i).style.height = data.data[i] + "px";
            }
          }
        });
      }

      return function cleanup() {
        document.getElementById('timber_demo_flash').innerHTML = "";

        socket.off('voicereturn');
      };
    },
    [ openByUser ]
  );

  return (
    <div id="voicepitchdiv">
      { !!isDisable &&
        <form className="microphone-form" action="#" id="mics">
          <div>Microphone:
            <select name="microphone" id="microphone-select" onChange={ () => window.microphone_selected() } style={{marginLeft: '1em'}}>
              <option value="none">No microphones detected</option>
            </select>
          </div>
        </form>
      }
      <div id="output">
        <div
            className = 'close-side-bar'
            onClick = { closeTool }>
            <Icon src = { IconClose } />
        </div>
        <table id="voice_pitch_table" style={{height: '150px', background: '#FAFAFA', border: '1px solid #CCCCCC', width: '100%'}}>
          <tbody><tr>
              <td><div className="bar" id="note-0" /><div className="caption">C</div></td>
              <td><div className="bar" id="note-1" /><div className="caption">C#</div></td>
              <td><div className="bar" id="note-2" /><div className="caption">D</div></td>
              <td><div className="bar" id="note-3" /><div className="caption">D#</div></td>
              <td><div className="bar" id="note-4" /><div className="caption">E</div></td>
              <td><div className="bar" id="note-5" /><div className="caption">F</div></td>
              <td><div className="bar" id="note-6" /><div className="caption">F#</div></td>
              <td><div className="bar" id="note-7" /><div className="caption">G</div></td>
              <td><div className="bar" id="note-8" /><div className="caption">G#</div></td>
              <td><div className="bar" id="note-9" /><div className="caption">A</div></td>
              <td><div className="bar" id="note-10" /><div className="caption">A#</div></td>
              <td><div className="bar" id="note-11" /><div className="caption">B</div></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default VoicePitch;
